import Bowser from 'bowser'

export default function validarBrowser (browser) {
  return Bowser.getParser(window.navigator.userAgent)
    .getBrowser().name.match((new RegExp(browser, 'gmi')))
}
